import { useId, useRef, type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const VSCodeInsidersLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id={`mask0_${id}`} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path
                    d="M16.5046 23.5002C16.9536 23.9493 17.6372 24.0656 18.2094 23.7904L23.1506 21.4143C23.6698 21.1645 24 20.6394 24 20.0632V3.95136C24 3.37523 23.6698 2.85007 23.1506 2.60037L18.2094 0.224138C17.6372 -0.0510468 16.9536 0.0652992 16.5046 0.514279C17.0578 -0.0389197 18.0037 0.35288 18.0037 1.13522V22.8793C18.0037 23.6617 17.0578 24.0534 16.5046 23.5002Z"
                    fill="white"
                />
                <path
                    d="M17.0043 16.9356L10.7184 12.0594L17.0043 7.07921V1.6682C17.0043 1.01699 16.2308 0.675648 15.7496 1.11435L6.99857 9.17362L2.92494 6.0135C2.54138 5.72242 2.00485 5.74633 1.64862 6.0701L0.327163 7.27152C-0.108607 7.66776 -0.109094 8.35265 0.325942 8.74963L15.7481 22.8924C16.2288 23.3332 17.0043 22.9921 17.0043 22.3399V16.9356Z"
                    fill="white"
                />
                <path
                    d="M3.44003 12.5808L0.325942 15.2652C-0.109094 15.6621 -0.108607 16.3472 0.327163 16.7432L1.64862 17.9446C2.00485 18.2684 2.54138 18.2923 2.92494 18.0012L6.51067 15.3804L3.44003 12.5808Z"
                    fill="white"
                />
            </mask>
            <g mask={`url(#mask0_${id})`}>
                <path
                    d="M15.7496 1.11434C16.2308 0.675648 17.0043 1.01699 17.0043 1.66821V7.07921L9.83794 12.7569L6.14758 9.95734L15.7496 1.11434Z"
                    fill="#009A7C"
                />
                <path
                    d="M3.44003 12.5807L0.325942 15.265C-0.109094 15.6621 -0.108607 16.3472 0.327163 16.7432L1.64862 17.9446C2.00485 18.2684 2.54138 18.2923 2.92494 18.0012L6.51067 15.3803L3.44003 12.5807Z"
                    fill="#009A7C"
                />
                <g filter={`url(#filter0_d_${id})`}>
                    <path
                        d="M17.0043 16.9355L2.92494 6.01343C2.54138 5.72236 2.00485 5.74627 1.64862 6.07004L0.327163 7.27146C-0.108607 7.6677 -0.109094 8.35259 0.325942 8.74957L15.7474 22.8916C16.2283 23.3327 17.0043 22.9914 17.0043 22.3388V16.9355Z"
                        fill="#00B294"
                    />
                </g>
                <g filter={`url(#filter1_d_${id})`}>
                    <path
                        d="M18.2093 23.7906C17.6372 24.0657 16.9535 23.9494 16.5045 23.5004C17.0577 24.0535 18.0037 23.6618 18.0037 22.8794V1.13534C18.0037 0.353002 17.0577 -0.0387974 16.5045 0.514401C16.9535 0.065421 17.6371 -0.0509241 18.2093 0.224259L23.1505 2.60049C23.6698 2.85019 24 3.37535 24 3.95148V20.0633C24 20.6395 23.6698 21.1647 23.1505 21.4144L18.2093 23.7906Z"
                        fill="#24BFA5"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id={`filter0_d_${id}`}
                    x="-21.3334"
                    y="-15.5232"
                    width="59.6711"
                    height="59.9468"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10.6667" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9769_3812" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9769_3812" result="shape" />
                </filter>
                <filter
                    id={`filter1_d_${id}`}
                    x="-4.8289"
                    y="-21.2569"
                    width="50.1623"
                    height="66.5285"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10.6667" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_9769_3812" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9769_3812" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
